/* eslint-disable */
import axios from "axios";

const state = {
	phrase: '',
	users: {
		data: null,
		meta: null,
		loading: false
	},
	posts: {
		loading: false,
		data: null,
		meta: null
	},
	groups: {
		loading: false,
		data: null,
		meta: null
	},
	comments: {
		loading: false,
		data: null,
		meta: null
	},
	problemIdeas: {
		loading: false,
		data: null,
		meta: null
	},
	notes: {
		loading: false,
		data: null,
		meta: null
	},
}

const getters = {
	phrase: (state) => {
		return state.phrase
	},
	users: (state) => {
		return state.users.data
	},
	usersLoading: (state) => {
		return state.users.loading
	},
	posts: (state) => {
		return state.posts.data
	},
	postsLoading: (state) => {
		return state.posts.loading
	},
	groups: (state) => {
		return state.groups.data
	},
	groupsLoading: (state) => {
		return state.groups.loading
	},
	comments: (state) => {
		return state.comments.data
	},
	commentsLoading: (state) => {
		return state.comments.loading
	},
	problemIdeas: (state) => {
		return state.problemIdeas.data
	},
	problemIdeasLoading: (state) => {
		return state.problemIdeas.loading
	},
	notes: (state) => {
		return state.notes.data
	},
	notesLoading: (state) => {
		return state.notes.loading
	},
}

const mutations = {
	setPostsLoading(state, payload) {
		state.posts.loading = payload;
	},
	setUsersLoading(state, payload) {
		state.users.loading = payload;
	},
	setGroupsLoading(state, payload) {
		state.groups.loading = payload;
	},
	setCommentsLoading(state, payload) {
		state.comments.loading = payload;
	},
	setProblemIdeasLoading(state, payload) {
		state.problemIdeas.loading = payload;
	},
	setNotesLoading(state, payload) {
		state.notes.loading = payload;
	},
	setUsersResults(state, payload) {
		state.users.data = payload.data
		state.users.meta = payload.meta
	},
	clearUsersResults(state) {
		state.users.data = null
		state.users.meta = null
	},
	setPostsResults(state, payload) {
		state.posts.data = payload.data
		state.posts.meta = payload.meta
	},
	clearPostsResults(state) {
		state.posts.data = null
		state.posts.meta = null
	},
	setGroupsResults(state, payload) {
		state.groups.data = payload.data
		state.groups.meta = payload.meta
	},
	clearGroupsResults(state) {
		state.groups.data = null
		state.groups.meta = null
	},
	setCommentsResults(state, payload) {
		state.comments.data = payload.data
		state.comments.meta = payload.meta
	},
	clearCommentsResults(state) {
		state.comments.data = null
		state.comments.meta = null
	},
	setProblemIdeasResults(state, payload) {
		state.problemIdeas.data = payload.data
		state.problemIdeas.meta = payload.meta
	},
	clearProblemIdeasResults(state) {
		state.problemIdeas.data = null
		state.problemIdeas.meta = null
	},
	setNotesResults(state, payload) {
		state.notes.data = payload.data
		state.notes.meta = payload.meta
	},
	clearNotesResults(state) {
		state.notes.data = null
		state.notes.meta = null
	},
	setPhrase(state, phrase) {
		state.phrase = phrase
	},
	clearPhrase(state) {
		state.phrase = ''
	}
}

const actions = {
	clearAllResults({ commit }) {
		commit('clearUsersResults')
		commit('clearPostsResults')
		commit('clearGroupsResults')
		commit('clearCommentsResults')
		commit('clearProblemIdeasResults')
		commit('clearNotesResults')
		commit('clearPhrase')
	},
	async mainSearchUsers({ commit }, { params }) {
		commit('setUsersLoading', true);
		let results = await getSearchResults({ type: 'users', params })
		commit('setUsersLoading', false);
		if (results.success) 
			commit('setUsersResults', results.data)
			
	},
	async mainSearchPosts({ commit }, { params }) {
		commit('setPostsLoading', true);
		let results = await getSearchResults({ type: 'posts', params })
		commit('setPostsLoading', false);
		if (results.success)
			commit('setPostsResults', results.data)
	},
	async mainSearchGroups({ commit }, { params }) {
		commit('setGroupsLoading', true);
		let results = await getSearchResults({ type: 'groups', params })
		commit('setGroupsLoading', false);
		if (results.success)
			commit('setGroupsResults', results.data)
	},
	async mainSearchComments({ commit }, { params }) {
		commit('setCommentsLoading', true);
		let results = await getSearchResults({ type: 'comments', params })
		commit('setCommentsLoading', false);
		if (results.success)
			commit('setCommentsResults', results.data)
	},
	async mainSearchProblemIdeas({ commit }, { params }) {
		commit('setProblemIdeasLoading', true);
		let results = await getSearchResults({ type: 'problem-ideas', params })
		commit('setProblemIdeasLoading', false);
		if (results.success)
			commit('setProblemIdeasResults', results.data)
	},
	async mainSearchNotes({ commit }, { params }) {
		commit('setNotesLoading', true);
		let results = await getSearchResults({ type: 'notes', params })
		ommit('setNotesLoading', false);
		if (results.success)
			commit('setNotesResults', results.data)
	},
	async mainSearchEntireData({ commit, dispatch }, { params }) {
		dispatch('clearAllResults')
		dispatch('mainSearchUsers', { params })
		dispatch('mainSearchPosts', { params })
		dispatch('mainSearchGroups', { params })
		commit('setPhrase', params.content)
		// dispatch('mainSearchComments', { params })
		// dispatch('mainSearchProblemIdeas', { params })
		// dispatch('mainSearchNotes', { params })
	},
}

async function getSearchResults ({ type, params }) {
	let responseData = null
	if (!params.sort_by)
		params.sort_by = 'new'
	await axios
		.get(`search/${type}`, {
			params
		})
		.then(response => {
			console.log("GET " + type.toUpperCase() +  " SEARCH SUCCESS", response);
			responseData = {
				data: response.data,
				success: true
			}
		})
		.catch(error => {
			console.log("GET SEARCH SUCCESS", error);
		})
	return responseData
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
